// extracted by mini-css-extract-plugin
export default {"log":"Log_log__-4sV5"};